<template>
    <BasePanel
        headline='lang_GENERIC_CAPTION_OTHER_IDS'
        :alvqa="alvqa"
    >
    <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="items"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
            >
            <!-- Topslot -->
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="isNewEntity"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                                
                            />
                        </v-col>
                    </v-row>
                </template>

            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.name`]="{ item, index }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="$alvPlugin.getOtherIdsRoleLabel(item)"
                            :alvqa="alvqa +'-list-row-' + index + '-text-name'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.type`]="{ item, index }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="getTypeText(item.type)"
                            :alvqa="alvqa +'-list-row-' + index + '-text-type'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.source`]="{ item, index }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.source !== null ? item.source : 'ALV'"
                            :alvqa="alvqa +'-list-row-' + index + '-text-source'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.value`]="{ item, index }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.value"
                            :alvqa="alvqa +'-list-row-' + index + '-text-value'"
                        />
                    </div>
                </template>
            <!-- Buttons -->
                <template v-slot:[`item.delete`]="{ item, index }">
                    <BaseIcon 
                        @click="deleteRow(item.id)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + '-list-row-' + index + '-icon-delete'"
                    />
                </template>
                <template v-slot:[`item.edit`]="{ item, index }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-' + index + '-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editRow(item)"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>
  
<script>
import BasePanel from "@/components/_base/BasePanel";
import BaseTooltip from "@/components/_base/BaseTooltip";
import BaseIcon from "@/components/_buttons/BaseIcon";
import BaseButton from '@/components/_buttons/BaseButton'
import {
    DropdownAzPersonsOtherIdsTypes
} from "@/assets/dropdowns/alvDropdowns.js";

export default {
    name: "OtherIdsPanel",
    components: {
        BasePanel,
        BaseTooltip,
        BaseIcon,
        BaseButton
    },
    data() {
        return {
            alvqa: "az-groups-edit-form-panel-other-ids",
            context: "AzGroupsOtherIds",
        };
    },
    computed: {
        items() {
            return this.$store.getters.getAzGroupsOtherIds;
        },
        itemsPerPage() {
            return this.$store.getters.getItemsPerPage;
        },
        headers() { 
            return [
                {
                    text: this.$t("lang_AZ_PERSONS_CAPTION_TYPE"),
                    value: "type",
                    alvqa: this.alvqa + "-header-type",
                    width: "160px"
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_SOURCE"),
                    value: "source",
                    alvqa: this.alvqa + "-header-source",
                    width: "90px"
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_ID"),
                    value: "value",
                    alvqa: this.alvqa + "-header-id",
                    width: "170px"
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_REMARK"),
                    value: "name",
                    alvqa: this.alvqa + "-header-name",
                },
                {
                    text: "",
                    value: "edit",
                    alvqa: this.alvqa + "-header-edit",
                    width: "50px"
                },
                {
                    text: "",
                    value: "delete",
                    alvqa: this.alvqa + "-header-delete",
                    width: "50px"
                }
            ]
        },
        isNewEntity() {
            return this.$route.params.alvId === 'new'
        },
    },
    methods: {
        addNewRow(){
            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultAzGroupsOtherIds))
            this.$store.commit('setAzGroupsOtherIdsEditingDialogDetails', defaultValues)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))
            this.$store.commit('setShowAzGroupsOtherIdsEditingDialog', true)
        },
        editRow(item) {
            this.$store.commit('setSelectedAzGroupsOtherIds', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))
            // set the copy in dialog details to edit
            this.$store.commit('setAzGroupsOtherIdsEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setAzGroupsOtherIdsPersonObjectOptions', [detailsDeepCopy.personObject])
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowAzGroupsOtherIdsEditingDialog', true) 
        },
        deleteRow(item){
            this.$store.commit('setSelectedAzGroupsOtherIds', item)
            this.$store.commit('setDeletionDialogContext', 'SelectedAzGroupsOtherIds')
            this.$store.commit('setShowDeletionDialog', true)
        },
        getTypeText(type) {
            let options = DropdownAzPersonsOtherIdsTypes;
            let result = options.find((el) => el.value == type)

            return result ? this.$t(result.text) : ""
        },
    }
  };
  </script>
  
  <style>
  .noMinWidth table {
    min-width: 0px !important;
    table-layout: fixed;
  }
  </style>